// import React, { useEffect, useState } from 'react';
// import '../styles/SplashScreen.css';

// const SplashScreen = ({ onComplete }) => {
//   const [showImage, setShowImage] = useState(false);
//   const [showText, setShowText] = useState(false);

//   useEffect(() => {
//     const imageTimeout = setTimeout(() => setShowImage(true), 150); // Image fades in first at 0.25s
//     const textTimeout = setTimeout(() => setShowText(true), 1200); // Text fades in after 1.5s
//     const splashTimeout = setTimeout(() => {
//       if (onComplete) onComplete();
//     }, 2000); // Entire splash screen lasts 3 seconds

//     return () => {
//       clearTimeout(imageTimeout);
//       clearTimeout(textTimeout);
//       clearTimeout(splashTimeout);
//     };
//   }, [onComplete]);

//   return (
//     <div className="splash-screen">
//       <img
//         src={require('../images/G-lawHub.png')} // Adjust path to your image
//         alt="Splash Logo"
//         className={`splash-image ${showImage ? 'fade-in-slow' : ''}`}
//       />
//       <h1 className={`splash-text ${showText ? 'fade-in-slow' : ''}`}>Global Law Hub</h1>
//     </div>
//   );
// };

// export default SplashScreen;





// import React, { useEffect, useState } from 'react';
// import '../styles/SplashScreen.css';
// import splashVideo from '../images/splash.mp4'; // Adjust path to your video

// const SplashScreen = ({ onFinish }) => {
//   const [fadeOut, setFadeOut] = useState(false);

//   useEffect(() => {
//     const fadeTimeout = setTimeout(() => setFadeOut(true), 3500); // Start fading out before removing
//     const removeTimeout = setTimeout(() => {
//       if (onFinish) onFinish(); // Call the function to remove the splash screen
//     }, 3500);

//     return () => {
//       clearTimeout(fadeTimeout);
//       clearTimeout(removeTimeout);
//     };
//   }, [onFinish]);

//   return (
//     <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
//       <video className="splash-video" autoPlay muted playsInline>
//         <source src={splashVideo} type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>
//     </div>
//   );
// };

// export default SplashScreen;


// import React, { useEffect, useState } from 'react';
// import '../styles/SplashScreen.css';
// import splashVideo from '../images/splash.mp4'; // Adjust path if needed

// const SplashScreen = ({ onFinish }) => {
//   const [fadeOut, setFadeOut] = useState(false);

//   useEffect(() => {
//     const fadeTimeout = setTimeout(() => setFadeOut(true), 1000); // Start fade-out at 3s
//     const removeTimeout = setTimeout(() => {
//       if (onFinish) onFinish(); // Call function to navigate to the main screen
//     }, 1000); // Fully remove splash screen at 3.5s

//     return () => {
//       clearTimeout(fadeTimeout);
//       clearTimeout(removeTimeout);
//     };
//   }, [onFinish]);

//   return (
//     <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
//       <video className="splash-video" autoPlay muted playsInline>
//         <source src={splashVideo} type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>
//     </div>
//   );
// };

// export default SplashScreen;

import React, { useEffect, useState } from 'react';
import '../styles/SplashScreen.css';

const SplashScreen = ({ onComplete }) => {
  const [showImage, setShowImage] = useState(false);
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    const imageTimeout = setTimeout(() => setShowImage(true), 50);   // Image almost instant
    const textTimeout = setTimeout(() => setShowText(true), 200);    // Text appears quickly
    const splashTimeout = setTimeout(() => {
      if (onComplete) onComplete();
    }, 1000); // Total splash screen time

    return () => {
      clearTimeout(imageTimeout);
      clearTimeout(textTimeout);
      clearTimeout(splashTimeout);
    };
  }, [onComplete]);

  return (
    <div className="navbar notranslate">
    <div className="splash-screen">

      <img
        src={require('../images/SpashScreen.png')}
        alt="Splash Logo"
        className={`splash-image ${showImage ? 'fade-in-slow' : ''}`}
      />
      {/* <h1 className={`splash-text ${showText ? 'fade-in-slow' : ''}`}>Global Law Hub</h1> */}
    </div>
    </div>
  );
};

export default SplashScreen;
